import { Position } from '@modusign/react-signing/types';

export function hasRequired(target: object): target is { required: boolean } {
  return 'required' in target;
}

export function hasPosition(target: object): target is { position: Position } {
  return 'position' in target;
}
